import { useEffect } from 'react';
import { FieldExtensionComponentProps } from "@backstage/plugin-scaffolder-react";
import { useAzureDevOpsOauthContext } from '../../hooks/useOauthContext';
import { ErrorPanel } from '@backstage/core-components';
import { z } from 'zod';
import { makeFieldSchema, useTemplateSecrets } from '@backstage/plugin-scaffolder-react';
import { AzureDevOpsOauthWrapper } from '../AzureDevOpsOauthWrapper';

const uiOptionsSchema = z.object({
    organization: z.string().describe('The Azure DevOps organization to query'),
    scopes: z.array(z.string()).describe('The scopes to use for the token'),
    message: z.string().describe('The message to display to the user').optional(),
});

export const AzureDevOpsTokenFieldSchema = makeFieldSchema({
	output: x => x.string(),
	uiOptions: zImpl => zImpl.object({
		organization: zImpl.string().describe('The Azure DevOps organization to query'),
		scopes: zImpl.array(zImpl.string()).describe('The scopes to use for the token'),
		message: zImpl.string().describe('The message to display to the user').optional(),
	}),
});

const AzureDevOpsTokenFieldComponent = (
    props: FieldExtensionComponentProps<string>,
) => {
    const { name } = props;
    const { token } = useAzureDevOpsOauthContext();
    const { setSecrets } = useTemplateSecrets();
    useEffect(() => {
        props.onChange('********');
        setSecrets({ [name]: token });
    }, [token]);
    return <></>;
};

export const AzureDevOpsTokenField = (props: FieldExtensionComponentProps<string, { organization: string, scopes: string[], message?: string }>) => {
    const result = uiOptionsSchema.safeParse(props.uiSchema['ui:options']);

    if (result.success) {
        return (
            <AzureDevOpsOauthWrapper {...props} scopes={result.data.scopes} message={result.data.message}>
                <AzureDevOpsTokenFieldComponent {...props} />
            </AzureDevOpsOauthWrapper>
        )
    }

    return <ErrorPanel error={result.error} />;
};
